import { forwardRef } from 'react'

import { IconProps } from '../../../types/types'

export const PolicySvg = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
	const { size = 24, ...rest } = props

	return (
		<svg
			ref={ref}
			width={size}
			height={size}
			viewBox="0 0 40 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...rest}>
			<path
				d="M14 5L28.3333 5L28.3333 29C28.3333 32.3137 25.647 35 22.3333 35L9.99998 35L9.99998 9C9.99998 6.79086 11.7908 5 14 5Z"
				fill="url(#paint0_linear_1_4113)"
			/>
			<path d="M16.6667 5L30 5L30 31C30 33.2091 28.2091 35 26 35L16.6667 35L16.6667 5Z" fill="#4A4A4A" />
			<path
				d="M25.8338 10C26.2938 10 26.6667 10.3729 26.6667 10.8329C26.6667 11.2928 26.2938 11.6657 25.8338 11.6657L14.1662 11.6657C13.7062 11.6657 13.3333 11.2928 13.3333 10.8329C13.3333 10.3729 13.7062 10 14.1662 10L25.8338 10Z"
				fill="white"
			/>
			<path
				d="M25.8338 14.9991C26.2938 14.9991 26.6667 15.372 26.6667 15.8319C26.6667 16.2919 26.2938 16.6648 25.8338 16.6648L14.1662 16.6648C13.7062 16.6648 13.3333 16.2919 13.3333 15.8319C13.3333 15.372 13.7062 14.9991 14.1662 14.9991L25.8338 14.9991Z"
				fill="white"
			/>
			<path
				d="M20.8338 19.9981C21.2937 19.9981 21.6666 20.371 21.6666 20.831C21.6666 21.2909 21.2937 21.6638 20.8338 21.6638L14.1662 21.6638C13.7062 21.6638 13.3333 21.2909 13.3333 20.831C13.3333 20.371 13.7062 19.9981 14.1662 19.9981L20.8338 19.9981Z"
				fill="white"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_1_4113"
					x1="0.00583461"
					y1="20"
					x2="18.7619"
					y2="30.3855"
					gradientUnits="userSpaceOnUse">
					<stop stopColor="#E4EDFC" />
					<stop offset="1" stopColor="#568DFE" />
				</linearGradient>
			</defs>
		</svg>
	)
})
